import md5 from 'js/md5';
import STORE from '../../vuex/index.js';
import jQuery from 'jquery';
import is_json from './is_json.js';
import toastr from 'toastr';

export default {
	//Configurações
	version: '2.0',
	key: '54b0a1df19868d82b4646b360d3722dc4d71e8e1f62fcb51f73890f34513802d8d4ef5a11051a2b1c99a537b7cfe4ee399bdb0bc613243ca0319c20c72a9b59f3d32a16c06f22a1b330de515ef363d8c25a667fd20d7265e7957d15b7c199d45471f3b1f43dc089d3109ab75f48b8072789fc40586b911537b4d5976f38e9c39',
	// url_base: 'http://localhost/enfcare2/wbs/',
	url_base: process.env.API,

	// funções
	access_key(acao) {
		//Validação inicial
		if (acao == undefined || acao == '') return false;
		let action_key = md5.get(acao + '-' + this.key);
		let info = acao.split('-');

		//validação de acao
		if (info.length != 3) return false;
		if (info[0] == 'public') {
			return action_key;
		} else {
			if (STORE.state.kSession != null) {
				return action_key + '.' + STORE.state.kSession;
			} else {
				return false;
			}
		}
	},
	send(acao, data, fx, type) {
		let token = this.access_key(acao);
		if (token != false) {
			//'Sec-Fetch-Site': 'cross-site'

			let preData = { token: token };
			let sType = type != undefined ? type : 'hibrid';
			let callback = null;

			preData.data =
				data != undefined && typeof data != 'function' ? data : null;
			if (typeof fx == 'string' && type == undefined) sType = fx;
			if (typeof data == 'function') callback = data;
			else if (typeof fx == 'function') callback = fx;

			// jQuery.ajax

			// console.log(preData)

			jQuery.post(
				`${process.env.API}?ac=${acao}`,
				preData,
				(resp) => {
					if (type == 'html' || type == 'json') callback(resp);
					else {
						if (is_json(resp)) callback(JSON.parse(resp));
						else {
							toastr.warning('500: Erro interno!');
							console.log(acao, resp);
							callback(resp);
						}
					}
				},
				'html'
			);

			//  jQuery.ajax({
			// 	url : `${process.env.API}?ac=${acao}`,
			// 	data: preData,
			// 	type: "POST",
			// 	// dataType: 'jsonp',
			// 	// Cache-Control: no-store
			// 	// headers: {'Access-Control-Allow-Origin': '*'},
			// })
			// .done(
			// 		resp => {

			// 			console.log(callback)
			// 			// console.log(acao, resp)
			// 			if(type == 'html' || type == 'json') callback(resp)
			// 			else{
			// 				if( is_json(resp) ) callback( JSON.parse(resp) )
			// 				else{
			// 					toastr.warning('500: Erro interno!')
			// 					console.log( acao, resp )
			// 					callback( resp )
			// 				}
			// 			}
			// 		} )
		} else {
			return false;
		}
	},
};



// WEBPACK FOOTER //
// ./src/assets/js/http.js